import React from 'react'
import { AppContainer, Header } from '@templatean/shared/components'
import EmailTracker from '../components/EmailTracker'

const EmailTrackerPage: React.FC = () => {
  return (
    <AppContainer>
      <Header 
        title="Email Tracker"
        subtitle="Track email engagement and analytics"
      />
      
      <div className="page-content">
        <EmailTracker />
      </div>
    </AppContainer>
  )
}

export default EmailTrackerPage